import { usePrimaryPage } from '@/PageManager'
import { pendingIdsAtom } from '@/atoms/pending'
import { HugeiconsIcon } from '@hugeicons/react'
import { CloudUploadIcon } from '@hugeicons/core-free-icons'
import SidebarItem from './SidebarItem'
import { useAtomValue } from 'jotai'

export default function PendingsButton({ collapse }: { collapse: boolean }) {
  const { navigate, current, display } = usePrimaryPage()
  const pendingIds = useAtomValue(pendingIdsAtom)

  if (pendingIds.length === 0) {
    return null
  }

  return (
    <SidebarItem
      title="Pending"
      onClick={() => navigate('pending')}
      active={display && current === 'pending'}
      collapse={collapse}
    >
      <HugeiconsIcon icon={CloudUploadIcon} />
    </SidebarItem>
  )
}
